var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{staticClass:"sd-volume-control",attrs:{"src":_vm.mutedStreams.includes(_vm.id) ? 'mute' : 'speaker'},on:{"click":_vm.handleClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }